import createAssigner from './_createAssigner.js';
import keys from './keys.js';

// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
export default createAssigner(keys);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/extendOwn.js
// module id = 245
// module chunks = 0